module.exports = __webpack_public_path__ + "img/back_rise.f77363cc.png";